import dashboardReducer from 'components/Dashboard/reducer'
import companyReducer from 'components/Company/reducer'
import contactReducer from 'components/Contact/reducer'
import contactsReducer from 'components/Contacts/reducer'
import dealsReducer from 'components/Deals/reducer'
import dealReducer from 'components/Deal/reducer'
import proposalsReducer from 'components/proposals/Proposals/reducer'
import proposalReducer from 'components/proposals/Proposal/reducer'
import companiesReducer from 'components/Companies/reducer'
import usersReducer from 'components/Users/reducer'
import appReducer from 'components/App/reducer'
import loadingReducer from 'components/Layout/reducer'
import notificationsReducer from 'components/Layout/Header/Notifications/reducer'
import calendarReducer from 'components/Calendar/reducer'
import adminReducer from 'components/Admin/Profile/reducer'
import listsReducer from 'components/Lists/reducer'
import headerReducer from 'components/Layout/Header/reducer'
import loginReducer from 'components/Login/reducer'
import sidebarReducer from 'components/ideal-core-ui/Sidebar/reducer'
import leadReducer from 'components/Leads/Lead/reducer'
import settingsReducer from './components/settings/reducer'

const reducers = {
  dashboard: dashboardReducer,
  company: companyReducer,
  contact: contactReducer,
  contacts: contactsReducer,
  deals: dealsReducer,
  deal: dealReducer,
  proposals: proposalsReducer,
  proposal: proposalReducer,
  companies: companiesReducer,
  users: usersReducer,
  app: appReducer,
  loading: loadingReducer,
  notifications: notificationsReducer,
  calendar: calendarReducer,
  admin: adminReducer,
  lists: listsReducer,
  header: headerReducer,
  sidebar: sidebarReducer,
  login: loginReducer,
  lead: leadReducer,
  settings: settingsReducer
}

export default reducers
